import type { SendsarEvent, SendsarEventMap } from "./types.js";

type Handler<E extends SendsarEvent> = (payload: SendsarEventMap[E]) => void;

export class EventEmitter {
  private readonly listeners = new Map<SendsarEvent, Set<Handler<SendsarEvent>>>();

  on<E extends SendsarEvent>(event: E, handler: Handler<E>): () => void {
    let set = this.listeners.get(event);
    if (!set) {
      set = new Set();
      this.listeners.set(event, set as Set<Handler<SendsarEvent>>);
    }
    set.add(handler as Handler<SendsarEvent>);
    return () => this.off(event, handler);
  }

  off<E extends SendsarEvent>(event: E, handler: Handler<E>): void {
    this.listeners.get(event)?.delete(handler as Handler<SendsarEvent>);
  }

  emit<E extends SendsarEvent>(event: E, payload: SendsarEventMap[E]): void {
    const set = this.listeners.get(event);
    if (!set) return;
    for (const handler of set) {
      handler(payload);
    }
  }

  removeAllListeners(): void {
    this.listeners.clear();
  }
}
